export enum EEvidenceExpiryStatus {
  EXPIRED = 'Expired',
  EXPIRING_SOON = 'Expiring Soon',
  VALID = 'Valid',
  NO_EXPIRY = 'No Expiry',
}

export enum EEvidenceStatus {
  Active = 'active',
  NotApplicable = 'not applicable',
  ToBeGenerated = 'to be generated',
  ToBeUploaded = 'to be uploaded',
  AlreadyUploadedAsPartOfOtherEvidences = 'already uploaded as part of other evidences',
  Success = 'success',
  ReminderSent = 'reminder sent',
}

export const evidenceStatusColorMap: Record<string, string> = {
  [EEvidenceStatus.Active]: 'green',
  [EEvidenceStatus.NotApplicable]: 'red',
  [EEvidenceStatus.ToBeGenerated]: 'blue',
  [EEvidenceStatus.ToBeUploaded]: 'yellow',
  [EEvidenceStatus.AlreadyUploadedAsPartOfOtherEvidences]: 'blue',
  [EEvidenceStatus.Success]: 'green',
  [EEvidenceStatus.ReminderSent]: 'orange',
} satisfies Record<EEvidenceStatus, string>;

export const evidenceStatusTextMap = {
  [EEvidenceStatus.Active]: 'Active',
  [EEvidenceStatus.NotApplicable]: 'Not Applicable',
  [EEvidenceStatus.ToBeGenerated]: 'To Be Generated',
  [EEvidenceStatus.ToBeUploaded]: 'To Be Uploaded',
  [EEvidenceStatus.AlreadyUploadedAsPartOfOtherEvidences]:
    'Already Uploaded As Part Of Other Evidences',
  [EEvidenceStatus.Success]: 'Success',
  [EEvidenceStatus.ReminderSent]: 'Reminder Sent',
};

export const EVIDENCE_EXPIRY_STATUS_COLORS = {
  [EEvidenceExpiryStatus.EXPIRED]: 'red',
  [EEvidenceExpiryStatus.NO_EXPIRY]: 'gray',
  [EEvidenceExpiryStatus.EXPIRING_SOON]: 'yellow',
  [EEvidenceExpiryStatus.VALID]: 'green',
};

export const dueDiligenceQuestionnaireEvidenceName =
  'Due Diligence Questionnaire';
